import { render, staticRenderFns } from "./arrears.vue?vue&type=template&id=4f427f85&"
import script from "./arrears.vue?vue&type=script&lang=js&"
export * from "./arrears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports